import { MultiSelect, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items as originalItems } from "designSystemLegacy/data";
import { cloneDeep } from "lodash";

export default () => {
	const items = cloneDeep(originalItems);

	const valuesSingle = items.slice(0, 4);

	items[1].disabled = true;
	items[3].disabled = true;
	items[5].disabled = true;

	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="normal" />
			<Text semiBold text="no chips" />
			<MultiSelect
				options={items}
				value={valuesSingle}
			/>
			<MultiSelect
				noChips
				options={items}
				placeHolderRes="Select"
				value={valuesSingle}
			/>
		</CssColumnGrid>
	);
};